export default __webpack_public_path__ + "static/slide-2-64e0afe424596f3d7d94b740d1f05d57.jpg";